export const AGREEMENT_LIST = [
    '快篩費用由家屬負擔，或您可提供全新快篩給照服員。',
    '任何非透過平台支付的費用，如紅包、小費、車馬費、餐費，皆為私下契約，平台不介入。',
    '我同意上述病患資料皆有如實填寫，若不實照服員可拒絕服務。',
];
